import Rewards from './Rewards';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import useRewardIconVariant from '@/hooks/theme/variants/useRewardIconVariant';
import { Button } from '@starsoft/common/components';
import { useRouter } from 'next/navigation';

export default function RewardsSection() {
  const { t } = useTranslation('common');
  const { isV2Version } = useRewardIconVariant();
  const { push } = useRouter();

  function handleViewAll() {
    push('/bonus');
  }

  return (
    <section
      className={`${styles.container} ${isV2Version ? styles['container--v2'] : ''}`}
    >
      <div className={styles.container__row}>
        <div className={styles.container__row__label}>
          <i className={`${styles.container__icon} fa-solid fa-tags`} />
          <h6 className={styles.container__title}> {t('promotions_label')}</h6>
        </div>
        <Button
          className={styles.container__row__button}
          isLinkButton
          onClick={handleViewAll}
        >
          {t('view_all')}
          <i className="fa-solid fa-chevron-right" />
        </Button>
      </div>

      <Rewards />
    </section>
  );
}
